/**
 * Shared size ordering/abbreviation helpers used anywhere size options are
 * rendered as pill buttons (CartEditModal, StockItemDetailsPage, ...).
 */

// Map full size names to abbreviations.
export const SIZE_ABBREVIATIONS = {
  small: "S",
  medium: "M",
  large: "L",
  "x-large": "XL",
  "2x-large": "2X",
  "3x-large": "3X",
};

// Size order from smallest to largest.
export const SIZE_ORDER = [
  "Small",
  "Medium",
  "Large",
  "X-Large",
  "2X-Large",
  "3X-Large",
];

export function getSizeAbbreviation(sizeLabel) {
  if (!sizeLabel) return sizeLabel;
  const normalized = String(sizeLabel).toLowerCase().trim();
  return SIZE_ABBREVIATIONS[normalized] || sizeLabel;
}

export function getSizeOrder(sizeLabel) {
  const index = SIZE_ORDER.findIndex(
    (size) => size.toLowerCase() === String(sizeLabel ?? "").toLowerCase()
  );
  return index >= 0 ? index : SIZE_ORDER.length;
}
